<template>
  <div class="popup-content-checkin">
    <card-checkin-small
      v-for="datum in dataForCards"
      v-bind:key="datum.id"
      v-bind="datum"
      class="content-item"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import CardCheckinSmall from '@/components/checkin/AppCardCheckinSmall.vue'

export default {
  name: 'AppMapPopupContentCheckin',
  components: {
    'card-checkin-small': CardCheckinSmall,
  },
  props: {
    /**
     * チェックインデータ
     */
    data: {
      type: Array,
      default: () => [],
    },
    /**
     * ソートキー
     */
    sortKey: {
      type: String,
      default: null,
    },
    /**
     * ソート方向
     * @values 'asc', 'desc'
     */
    sortDirection: {
      type: String,
      default: 'asc',
    },
  },
  computed: {
    /**
     * カード用データ
     * @type {Array.<Object>}
     */
    dataForCards: function () {
      if (!this.data) return []

      let data = [...this.data]

      if (this.sortKey) {
        data.sort(this.sortFunction)
      }

      return data.map((datum) => {
        return {
          id: datum.id,
          userId: datum.user_id,
          userName: datum.user_name,
          updateAt: datum.checkin_update_at,
        }
      })
    },
    /**
     * ソート関数
     * @type {Function}
     */
    sortFunction: function () {
      if (this.sortDirection === 'asc') {
        return (a, b) => {
          const valueA = a[this.sortKey]
          const valueB = b[this.sortKey]
          if (valueA === valueB) return 0
          return valueA > valueB ? 1 : -1
        }
      } else if (this.sortDirection === 'desc') {
        return (a, b) => {
          const valueA = a[this.sortKey]
          const valueB = b[this.sortKey]
          if (valueA === valueB) return 0
          return valueA > valueB ? -1 : 1
        }
      } else {
        return () => 0
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.popup-content-checkin {
  max-width: 15rem;
  max-height: calc(4.5rem * 5.5);
  overflow-x: hidden;
  overflow-y: auto;
  @include mixin-scrollbar;
}

.content-item {
  &:first-child {
    padding-top: 4px;
    height: calc(4rem + 4px);
  }

  &:last-child {
    padding-bottom: 4px;
    height: calc(4rem + 4px);
    border-bottom: 1px solid transparent;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #e3e3e3;
  }
}
</style>
